import { Link, usePage } from '@inertiajs/react'
import { useTranslation } from '@/lib/i18n'
import type { SharedProps } from '@/types'

/** Separate our decorative work from the branded lighter and avoid inventing a warranty term. */
export function MakerDetails({ isLighter, isShell }: { isLighter: boolean; isShell: boolean }) {
  const { seller } = usePage<SharedProps>().props
  const { t } = useTranslation()
  if (!seller) return null

  return (
    <details id="maker-details" className="mt-4 border-t border-hairline pt-1 text-sm leading-relaxed text-ink-muted">
      <summary className="cursor-pointer py-3 font-medium text-ink focus-visible:outline focus-visible:outline-2">{t('product.maker_title')}</summary>
      <div className="space-y-3 pb-1">
        <p>{t(isShell ? 'product.maker_label' : 'product.maker_other')}<br />{seller.name}, {t('requisites.unp')} {seller.unp}<br />{seller.address}</p>
        <p>{t('product.warranty')}</p>
        {isLighter && <p>{t('product.cricket_origin')}</p>}
        <p>{t('product.maker_contact')} <a href={`mailto:${seller.email}`} className="underline underline-offset-4">{seller.email}</a></p>
        <Link href="/delivery" className="inline-block underline underline-offset-4">{t('product.delivery_link')}</Link>
      </div>
    </details>
  )
}
